import { Box, InputAdornment, SxProps, TextField } from '@mui/material'
import clsx from 'clsx'
import { ReactNode } from 'react'

import style from './TextFieldDescribed.module.css'

interface Props {
  description: string
  error?: string
  hasError?: boolean
  defaultValue?: string | number
  value?: string | number
  placeholder: string
  disabled?: boolean
  type?: string
  rightLabel?: string
  className?: string
  onChange: (e: any) => void
  children?: ReactNode
  sxInput?: SxProps
}

const TextFieldDescribed = ({
  description,
  error = '',
  hasError = false,
  defaultValue,
  placeholder,
  disabled = false,
  rightLabel,
  type = 'text',
  className,
  onChange,
  children,
  value,
  sxInput = {},
}: Props) => {
  return (
    <div className={className}>
      <Box className={clsx('text-14-400', style.subtitle)}>{description}</Box>
      <div className={style.flexRow}>
        <TextField
          variant="outlined"
          placeholder={placeholder}
          fullWidth
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
          type={type}
          sx={{
            '& fieldset': {
              border: hasError ? 'solid 1px #dc664d' : 'solid 1px #DADDE5',
            },
            '& .MuiInputBase-root': {
              height: '40px',
              fontSize: '14px',
            },
            ...sxInput,
          }}
          InputProps={{
            endAdornment: children && <InputAdornment position="end">{children}</InputAdornment>,
          }}
        />
        {rightLabel && <div className={style.rightLabel}>{rightLabel}</div>}
      </div>
      {hasError ? <div className={style.error}>{error}</div> : null}
    </div>
  )
}

export default TextFieldDescribed
